module.exports = __webpack_public_path__ + "static/img/toolBg.8f53c54e.png";